import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ASSETS_PATH } from 'src/app/core/config';
import { RefereeForm } from 'src/app/core/models/refereeForm.model';
import { UserBasicInfo } from 'src/app/core/models/user.model';
import { AlertService } from 'src/app/core/services/alert.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { RefereeFormService } from 'src/app/core/services/refereeForm.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-referee-form',
  templateUrl: './referee-form.component.html',
  styleUrls: ['./referee-form.component.scss']
})
export class RefereeFormComponent implements OnInit {
  userBasicInfo = new UserBasicInfo();
  refereeForm = new RefereeForm();
  createRefereeForm: FormGroup;
  assetsPath = ASSETS_PATH;
  isImage = false;
  isFilled = false;
  selectedRoles = [];

  constructor(private alertService: AlertService,
    private refereeFormService: RefereeFormService,
    private userService: UserService,
    private loadingService: LoadingService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.createRefereeForm = this.formBuilder.group({
      isConflict: new FormControl('', [
        Validators.required
      ]),
      isVolunteeredBefore: new FormControl('', [
        Validators.required
      ]),
      volunteerExperience: new FormControl('', [
        Validators.maxLength(200)
      ]),
      isOtherProgram: new FormControl('', [
        Validators.required
      ]),
      programExperience: new FormControl('', [
        Validators.maxLength(250)
      ])
    });
    this.loadingService.setLoading(true);
    this.userService.getUserBasicInfo().subscribe(response => {
      if (response.success) {
        this.userBasicInfo = response;
        if (this.userBasicInfo.image !== null && this.userBasicInfo.image !== "") {
          this.isImage = true;
        }
        this.loadingService.setLoading(false);
      }
    },
      (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
      });

    this.loadingService.setLoading(true);
    this.refereeFormService.isRefereeForm().subscribe(response => {
      if (response.success) {
        this.isFilled = response.isFilled;
        this.loadingService.setLoading(false);
      }
    },
      (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
      });
  }

  save() {
    if (this.createRefereeForm.invalid) {
      this.alertService.alert('Hata', 'Lütfen formdaki alanları eksiksiz tamamlayınız!', 'error')
      return;
    }
    if (this.createRefereeForm.valid) {
      this.loadingService.setLoading(true);
      let data = Object.assign({}, this.createRefereeForm.value);

      this.refereeForm.isConflict = data.isConflict == "yes";
      this.refereeForm.isVolunteeredBefore = data.isVolunteeredBefore == "yes";
      this.refereeForm.volunteerExperience = "";
      this.refereeForm.isOtherProgram = data.isOtherProgram == "yes";
      this.refereeForm.programExperience = data.programExperience;
      if (this.selectedRoles.length != 0) {
        this.refereeForm.volunteerExperience = this.selectedRoles.join(", ");
      }

      this.refereeFormService.createRefereeForm(this.refereeForm).subscribe(response => {
        if (response.success) {
          this.alertService.alert('Başarılı!', 'Hakem başvuru formunuz kaydedildi!', 'success')
          this.router.navigate(['/my-profile']);
        }
        this.loadingService.setLoading(false);
      }, (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
      })
    }
  }

  get f() {
    return this.createRefereeForm.controls;
  }

  onRoleChange(id:string, isChecked: boolean) {
    if(isChecked) {
      this.selectedRoles.push(id);
    } else {
      let index = this.selectedRoles.indexOf(id);
      this.selectedRoles.splice(index,1);
    }
  }

}
